<template>
  <div :id="'alertAccordion-' + index + '-' + name" :class="'accordion ' + bgClass">
    <div class="accordion-item">
      <h2 class="accordion-header">
        <button
          :class="'accordion-button ' + (alertLength > 1 ? 'collapsed' : '')"
          type="button"
          data-bs-toggle="collapse"
          :data-bs-target="'#alertCollapse-' + index + '-' + name"
          :aria-expanded="alertLength < 1"
          :aria-controls="'alertCollapse-' + index + '-' + name"
        >
          <span>
            <FontAwesomeIcon :icon="'fa-light fa-' + icon" class="me-2" />
            {{ alert.longLabel }}
          </span>
          <span class="detail">{{ isCollapsed ? $t("global.collapse_show") : $t("global.collapse_reduce") }}</span>
        </button>
      </h2>
      <div
        :id="'alertCollapse-' + index + '-' + name"
        :class="'accordion-collapse collapse ' + (alertLength > 1 ? '' : 'show')"
        :data-bs-parent="'#alertAccordion-' + index + '-' + name"
      >
        <!-- ST143-TI-17771 (c-group 1, KEEP + SANITIZE): back-office WYSIWYG alert description. -->
        <div class="accordion-body alert" v-safe-html="alert.description"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { alertManager } from "@/services/alert/alert-manager";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

export default {
  name: "FormCollapseAlertComponent",
  components: { FontAwesomeIcon },
  props: {
    alert: {
      type: Object,
      required: true,
    },
    name: {
      type: String,
      required: true,
    },
    index: {
      type: Number,
      required: true,
    },
    alertLength: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      isCollapsed: this.alertLength > 1,
    };
  },
  emits: [],
  computed: {
    bgClass() {
      return alertManager.getAlertColor(this.alert.level);
    },

    icon() {
      return alertManager.getAlertIcon(this.alert.level);
    },
  },
  watch: {},
  mounted() {
    const collapseEl = document.getElementById("alertCollapse-" + this.index + "-" + this.name);
    if (collapseEl) {
      this._showHandler = () => {
        this.isCollapsed = false;
      };
      this._hideHandler = () => {
        this.isCollapsed = true;
      };
      collapseEl.addEventListener("show.bs.collapse", this._showHandler);
      collapseEl.addEventListener("hide.bs.collapse", this._hideHandler);
      this._collapseEl = collapseEl;
    }
  },
  beforeUnmount() {
    if (this._collapseEl) {
      this._collapseEl.removeEventListener("show.bs.collapse", this._showHandler);
      this._collapseEl.removeEventListener("hide.bs.collapse", this._hideHandler);
    }
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
.accordion {
  margin-left: 10px;
  border-radius: 6px;
  border: none;
  border-left: 4px solid;

  &.-info {
    border-color: $purple !important;
    @include dark-theme {
      border-color: $light-purple !important;
    }

    .accordion-collapse {
      &.show,
      &.collapsing {
        border-color: $purple !important;
        @include dark-theme {
          border-color: $light-purple !important;
        }
      }
    }

    .accordion-header {
      background: $light-purple !important;
      color: $purple !important;
      @include dark-theme {
        background: $purple !important;
        color: $light-purple !important;
      }

      .accordion-button::after {
        background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23546bd1'%3e%3cpath fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/%3e%3c/svg%3e");
      }
      .accordion-button:not(.collapsed)::after {
        background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23546bd1'%3e%3cpath fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/%3e%3c/svg%3e");
      }
    }
  }

  &.-warning {
    border-color: $orange !important;
    @include dark-theme {
      border-color: $light-orange !important;
    }

    .accordion-collapse {
      &.show,
      &.collapsing {
        border-color: $orange !important;
        @include dark-theme {
          border-color: $light-orange !important;
        }
      }
    }

    .accordion-header {
      background: $light-orange !important;
      color: $orange !important;
      @include dark-theme {
        background: $orange !important;
        color: $light-orange !important;
      }

      .accordion-button::after {
        background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23f8a007'%3e%3cpath fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/%3e%3c/svg%3e");
      }
      .accordion-button:not(.collapsed)::after {
        background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23f8a007'%3e%3cpath fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/%3e%3c/svg%3e");
      }
    }
  }

  &.-danger {
    border-color: $red !important;
    @include dark-theme {
      border-color: $light-red;
    }

    .accordion-collapse {
      &.show,
      &.collapsing {
        border-color: $red !important;
        @include dark-theme {
          border-color: $light-red !important;
        }
      }
    }

    .accordion-header {
      background: $light-red !important;
      color: $red !important;

      @include dark-theme {
        background: $red;
        color: $light-red;
      }

      .accordion-button::after {
        background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23da5164'%3e%3cpath fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/%3e%3c/svg%3e");
      }
      .accordion-button:not(.collapsed)::after {
        background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23da5164'%3e%3cpath fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/%3e%3c/svg%3e");
      }
    }
  }

  &.-neutral {
    border-color: $grey !important;
    @include dark-theme {
      border-color: $m-color_2 !important;
    }

    .accordion-collapse {
      &.show,
      &.collapsing {
        border-color: $grey !important;
        @include dark-theme {
          border-color: $m-color_2 !important;
        }
      }
    }

    .accordion-header {
      background: $m-color_2 !important;
      color: grey !important;
      @include dark-theme {
        background: grey !important;
        color: $m-color_2 !important;
      }

      .accordion-button::after {
        background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23f8a007'%3e%3cpath fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/%3e%3c/svg%3e");
      }
      .accordion-button:not(.collapsed)::after {
        background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23f8a007'%3e%3cpath fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/%3e%3c/svg%3e");
      }
    }
  }
}

.accordion,
.accordion-button,
.accordion-item {
  color: inherit !important;
  background-color: transparent !important;
}

.accordion-button {
  border-bottom: 0 !important;
  font-weight: 600;
  display: flex;
  justify-content: space-between;
  align-items: baseline;
}

.accordion-header {
  color: inherit !important;
  margin-bottom: 0 !important;

  @include dark-theme {
    background-color: transparent !important;
  }
}

.accordion-collapse {
  &.show,
  &.collapsing {
    border-top: 1px solid;
  }
}

.accordion-body {
  @include dark-theme {
    color: $dark-text;
    background-color: transparent !important;
  }
}

.accordion-item {
  @include dark-theme {
    border: none;
  }
}

.detail {
  font-weight: 400;
  font-size: 14px;
}
</style>
<style lang="scss">
.modal-content .modal-body .accordion-body.alert p,
.modal-content .modal-body .accordion-body.alert ul,
.modal-content .modal-body .accordion-body.alert li {
  color: inherit !important;
}
</style>
